// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__OTj3I","productName":"Table_productName__3Vo3z"};